import { useNavigate } from 'react-router-dom';
import { restaurants } from '@/mocks/hotelData';

export default function RestaurantSection() {
  const navigate = useNavigate();

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-xs md:text-sm text-accent-500 tracking-widest uppercase font-medium">
            Michelin Starred Dining
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mt-2 mb-3">
            米其林星级餐厅
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            新葡京酒店汇聚澳门最多米其林星级餐厅，为您呈现世界顶级美食体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {restaurants.map((restaurant) => (
            <article
              key={restaurant.id}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-accent-300/50 transition-all duration-300 cursor-pointer"
              onClick={() => navigate('/category/dining')}
            >
              <div className="relative h-48 md:h-56 overflow-hidden">
                <img
                  src={restaurant.imageUrl}
                  alt={restaurant.name}
                  title={`${restaurant.name} - 新葡京酒店`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-full">
                    {restaurant.rating}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-1">{restaurant.name}</h3>
                <p className="text-xs text-foreground-500 mb-2">{restaurant.nameEn} · {restaurant.cuisine}</p>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-2">{restaurant.description}</p>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line text-sm"></i> {restaurant.hours}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-map-pin-line text-sm"></i> {restaurant.location}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-10">
          <button
            onClick={() => navigate('/category/dining')}
            className="px-8 py-3 border-2 border-accent-500 text-accent-600 font-medium rounded-lg hover:bg-accent-500 hover:text-background-50 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
          >
            探索更多美食
          </button>
        </div>
      </div>
    </section>
  );
}